import { Component, OnInit, Input } from '@angular/core';
import { Location} from '@angular/common';

import { UnitOfWork, provideParent, StateMap } from '../../services/common';
import { PageState, EditPropParent } from '../../controls/common';
import { RIFMProduct, TypeLinkTarget } from  '../../entities/EntityModels';

export type LinkType = 'File' | 'RIFMProduct' | 'RIFMSecureProduct' | 'ToolSetupFile';

@Component({
    selector: 'tools-and-model',
    templateUrl: './tools-and-model.html',
    providers: [provideParent(ToolsAndModelComponent, EditPropParent)]
})
export class ToolsAndModelComponent implements OnInit {
    @Input() entity: RIFMProduct;
    _typeLinkTargets: TypeLinkTarget[];
    _pageState = new PageState('Tools and Models Editor');

    // used to prepopulate the action description
    _linkActionDescriptions: Record<LinkType, string>;

    constructor(public _uow: UnitOfWork, public _stateMap: StateMap, public _location: Location) {

        this._linkActionDescriptions = {
            File: 'Click to Download the Data File',
            RIFMProduct: 'Click to Open Online Tool',
            RIFMSecureProduct: 'Click to Open Online Tool',
            ToolSetupFile: 'Click to Download the Setup File',
        };
    }

    ngOnInit() {
        this._uow.typeLinkTargetRepository.all().then( r => {
            this._typeLinkTargets = r;
        });

    }

    getError(propName: string) {
        return this.entity.getErrorFor(propName);
    }

    onSelectLinkTargetType(linkType: string) {
        this.entity.linkTargetType = linkType;
        this.entity.actionDescription = this._linkActionDescriptions[linkType as LinkType];

        // For new types. This value can be added or modified in the UI.
        if (!this.isValidString(this.entity.actionDescription)) {
            this.entity.actionDescription = 'Click to Download';
        }
    }

    isValidString(teststring: string) {
        if (!teststring || !teststring.trim) { return false; }

        return (teststring.trim().length > 0);
    }
}
